import { Box, Button as MuiButton, Grid, Stack } from "@mui/material";

import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import React, { useState } from "react";
import { PagePaper, SectionPaper } from "@/components/Paper";
import { PageTitle } from "@/components/Title";
import { FeedGrid } from "../components/ExcludedCustomerListFeedGrid";
import { useApiClient } from "../../../hooks/useApiClient";
import type { CustomerStatusDataGridRow, FilterCondition } from "../types";
import { FilteringCondition } from "../components/FilteringCondition";
import { GetCustomerListAPI } from "../api";
import { Link as RouterLink } from "react-router-dom";

export const ExcludedCustomerList: React.FC = () => {
  const [rows, setRows] = useState<CustomerStatusDataGridRow[]>([]);

  // 検索条件の状態管理
  const [filterCondition, setFilterCondition] = useState<FilterCondition>({
    prefectures: [],
    cities: [],
    // 不動産種別
    realEstateTypeTochi: false,
    realEstateTypeKutate: false,
    realEstateTypeTatemono: false,
  });
  const { apiClient } = useApiClient();

  const handleFiltering = async (): Promise<void> => {
    // バリデーションチェック
    if (
      filterCondition.prefectures.length === 0 ||
      filterCondition.cities.length === 0
    ) {
      // バリデーションエラーがある場合は処理を中断
      return;
    }

    const realEstateTypes: string[] = [];
    if (filterCondition.realEstateTypeKutate)
      realEstateTypes.push("CONDOMINIUM");
    if (filterCondition.realEstateTypeTatemono)
      realEstateTypes.push("BUILDING");
    if (filterCondition.realEstateTypeTochi) realEstateTypes.push("LAND");

    const response = await GetCustomerListAPI(
      apiClient,
      "/real-estate-owner-customer-management/excluded-customer-list",
      filterCondition.cities,
      filterCondition.prefectures,
      realEstateTypes
    );
    setRows(response);
  };

  return (
    <PagePaper>
      <form>
        <Box sx={{ display: "flex" }}>
          {/* ページタイトル */}
          <Box sx={{ display: "flex", mb: 3 }}>
            <ManageSearchIcon sx={{ mr: 1 }} fontSize="large" />
            <PageTitle>対象外顧客一覧</PageTitle>
          </Box>
        </Box>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs>
            <Stack my={2} direction="row" justifyContent="end" spacing={1}>
              <MuiButton
                variant="contained"
                size="large"
                component={RouterLink}
                to={"/customermanagement/customerlist"}
              >
                顧客一覧
              </MuiButton>
            </Stack>
          </Grid>
        </Grid>

        {/* フィルタ部分 */}
        <FilteringCondition
          filterCondition={filterCondition}
          handleFiltering={() => {
            (async () => {
              await handleFiltering();
            })();
          }}
          setFilterCondition={setFilterCondition}
        />

        <Box sx={{ mt: 3 }} />

        <SectionPaper>
          <FeedGrid rows={rows} />
          <Box sx={{ mb: 6 }} />
          <Stack
            direction={"row"}
            spacing={4}
            justifyContent={"center"}
            mb={2}
          />
        </SectionPaper>
      </form>
    </PagePaper>
  );
};
